import appConfig from '../../app-config';

const environment = process.env.GATSBY_ENV;

export const initialize = session_id => {
  // use it from app config
  const trackingId = 'UA-151239665-1';

  const {gtag} = window;

  // connect to google analytics
  if (environment === 'production' && appConfig.googleAnalyticsTrackingId) {
    gtag('config', appConfig.googleAnalyticsTrackingId, {userId: session_id});
    // gtag('config', trackingId, {userId: session_id});
  }

  if (environment === 'production' && appConfig.googleAnalyticsMeasurementId) {
    gtag('config', appConfig.googleAnalyticsMeasurementId, {
      linker: {
        accept_incoming: true,
      },
    });
  }

  // connect to google ads via conversion id
  if (environment === 'production' && appConfig.googleAdwordsId) {
    gtag('config', appConfig.googleAdwordsId);
  }

  // gtag('pageview', window.location.pathname);
};

export const reportConversion = url => {};

export default {initialize};
